// extracted by mini-css-extract-plugin
module.exports = {"text":"themeGuideModal_text__2w8S3"};